import React from 'react';
import classNames from 'classnames';
import { IconButton } from 'jl-design-system/components/button/Button';
import { CloseOutlined } from 'jl-design-system/components/icons/CloseOutlined';
import styles from './FlyoutMenu.scss';

type CloseButtonProps = {
  onClose: () => void;
  className?: string;
};

export const CloseButton = ({ onClose, className }: CloseButtonProps) => {
  return (
    <IconButton
      className={classNames(styles.close, className)}
      onClick={onClose}
      icon={CloseOutlined}
      background="clear"
      data-testid="nav-close-button"
      aria-label="Close"
    ></IconButton>
  );
};
